import { sendMessageToSentry } from 'lib/utils/sentryUtils'

/**
 *
 * @param itemDiscount The item discount to format
 * @param transactionKey The transaction key of the cart item this discount belongs to
 * @returns the formatted item discount to be send to svc-order
 */
function formatItemDiscount(itemDiscount: App.Checkout.ItemDiscount, transactionKey?: string): App.Checkout.FormattedItemDiscount {
  const isTourOptionalExperience = itemDiscount.subCategoryBK === 'tour-tour_optional_experience_items'
  const appliedVouchers = itemDiscount.appliedVoucher?.map((voucher) => {
    if (transactionKey && transactionKey.length > 0 && voucher.transactionKey !== transactionKey && !isTourOptionalExperience) {
      // send an error message to sentry
      sendMessageToSentry('Checkout:Promo/Vouchers:formatItemDiscount:Applied voucher transaction key does not match the cart item transaction key', undefined, {
        voucher_id: voucher.voucherId,
        voucher_user_id: voucher.voucherUserId,
        transaction_key: voucher.transactionKey,
        cart_transaction_key: transactionKey,
      })
    }
    return {
      item_id: voucher.itemId,
      transaction_key: transactionKey && transactionKey.length > 0 ? transactionKey : voucher.transactionKey,
      voucher_id: voucher.voucherId,
      voucher_reward_id: voucher.voucherRewardId,
      voucher_title: voucher.voucherTitle,
      voucher_description: voucher.voucherDescription,
      amount: voucher.amount,
      remaining_amount_after: voucher.remainingAmountAfter,
      voucher_user_id: voucher.voucherUserId,
      voucher_toggles: voucher.voucherToggles,
      theme: voucher.theme,
      product_type: voucher.productType,
      ...(voucher.rewardKind !== undefined ? { reward_kind: voucher.rewardKind } : {}),
      ...(voucher.creditAmount !== undefined ? { credit_amount: voucher.creditAmount } : {}),
      ...(voucher.itemEndDate !== undefined ? { item_end_date: voucher.itemEndDate } : {}),
      ...(voucher.creditPayoutAt !== undefined ? { credit_payout_at: voucher.creditPayoutAt } : {}),
    }
  })

  return {
    item_id: itemDiscount.itemId,
    offer_id: itemDiscount.offerId,
    category_bk: itemDiscount.categoryBK,
    sub_category_bk: itemDiscount.subCategoryBK,
    transaction_key: transactionKey,
    discount_value: itemDiscount.discountValue,
    discount_type: itemDiscount.discountType,
    discount_amount: itemDiscount.discountAmount,
    discountable_total: itemDiscount.discountableTotal,
    hide_discount_percentage: itemDiscount.hideDiscountPercentage,
    item_info_string: itemDiscount.itemInfoString,
    ...(appliedVouchers?.length ? { applied_voucher: appliedVouchers } : {}),
  }
}

export default formatItemDiscount
